'use client';

import { Check, Copy } from '@phosphor-icons/react/dist/ssr';
import { useState } from 'react';
import { Button } from './button';
import { Tooltip } from './tooltip';
function CopyToClipboard({
  alignTooltipEnd,
  content
}: {
  alignTooltipEnd: boolean;
  content: string;
}) {
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(content);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };
  return <Tooltip tooltip="Copy to clipboard" hideOnMobile alignEnd={alignTooltipEnd} data-sentry-element="Tooltip" data-sentry-component="CopyToClipboard" data-sentry-source-file="copy-to-clipboard.tsx">
      <Button onClick={handleCopy} className="w-4 h-6" variant="ghost" size="icon" data-sentry-element="Button" data-sentry-source-file="copy-to-clipboard.tsx">
        {isCopied ? <Check weight="bold" size={18} /> : <Copy weight="bold" size={18} />}
      </Button>
    </Tooltip>;
}
export default CopyToClipboard;